import React from 'react';
import PropTypes from 'prop-types';

import Credits from './Credits';

const propTypes = {
    credits: PropTypes.array,
};

const defaultProps = {
    credits: [
        {
            title: 'The film',
            items: [
                {
                    label: 'Featuring',
                    items: [
                        'Sarah Leavens',
                        'Jessy Bokser',
                        'Von Allan',
                    ],
                },
                {
                    label: 'Writer & Director',
                    items: [
                        'Megan Durnford',
                    ],
                },
                {
                    label: 'Producer',
                    items: [
                        'Katarina Soukup',
                    ],
                },
                {
                    label: 'Director of Photography',
                    items: [
                        'Alex Margineanu',
                    ],
                },
                {
                    label: 'Editor',
                    items: [
                        'Howard Goldberg',
                    ],
                },
                {
                    label: 'Original Music',
                    items: [
                        'Alain Auger',
                    ],
                },
                {
                    label: 'Sound Design',
                    items: [
                        'Luc Raymond',
                    ],
                },
            ],
        },
        {
            title: 'Web & Impact Campaign',
            items: [
                {
                    label: 'Impact Producers',
                    items: [
                        'Stéphanie Couillard',
                        'Katarina Soukup',
                    ],
                },
                {
                    label: 'Art Direction',
                    items: [
                        'Sara Morley, Design Postimage',
                    ],
                },
                {
                    label: 'Programming',
                    items: [
                        'Nicolas Roy B., Folklore',
                        'David Mongeau-Petitpas, Folklore',
                        'Hugo St-Onge, Folklore',
                    ],
                },
                {
                    label: 'Web Capsules',
                    items: [
                        'Tamara Scherbak',
                        'Faisal Lutchmedial',
                    ],
                },

                {
                    label: 'Content Consultant',
                    items: [
                        'Megan Durnford',
                    ],
                },
                {
                    label: 'Animation',
                    items: [
                        'Eva Cvijanovic',
                        'Malcolm Sutherland',
                        'Simon Cottee',
                    ],
                },
            ],
        },
    ],
};

const FilmCredits = ({ credits }) => (
    <div className="credits">
        <h4 className="subtitle">Key credits</h4>
        { credits.map(({ title, items }) => (
            <div className="credits-section" key={`credits-${title}`}>
                <h4 className="subtitle color-black">{ title }</h4>
                <Credits credits={items} />
            </div>
        )) }
    </div>
);

FilmCredits.propTypes = propTypes;
FilmCredits.defaultProps = defaultProps;

export default FilmCredits;



// WEBPACK FOOTER //
// ./components/partials/FilmCredits.jsx